/**
 * @fileoverview GET handler for the "/companies/:company_id/sender_verification/ip_addresses" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { companiesCompanyIdSenderVerificationIpAddresses } from "./constants";
import type { CompaniesCompanyIdSenderVerificationIpAddressesResult } from "./types";

export const getCompaniesCompanyIdSenderVerificationIpAddresses = reactQueryFetcherAdapter(
  companiesCompanyIdSenderVerificationIpAddresses,
  (signal: AbortSignal, companyId: string): Promise<CompaniesCompanyIdSenderVerificationIpAddressesResult> => {
    return fetch(`/companies/${companyId}/sender_verification/ip_addresses`, "GET", {}, { signal });
  }
);
